import { Box, Button, Container, Typography, Stack } from "@mui/material";
import React from "react";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function PageNotFound() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <React.Fragment>
            <Box
                component="main"
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.mode === 'light'
                            ? theme.palette.grey[100]
                            : theme.palette.grey[900],
                    alignItems: 'center',
                    display: 'flex',
                    flexGrow: 1,
                    minHeight: '100vh',
                    py: 4
                }}
            >
                <Container maxWidth="md">
                    <Box
                        sx={{
                            textAlign: 'center',
                            py: { xs: 4, md: 6 }
                        }}
                    >
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 120,
                                height: 120,
                                borderRadius: '50%',
                                bgcolor: 'error.main',
                                color: 'white',
                                mb: 3,
                                boxShadow: 3
                            }}
                        >
                            <ErrorOutlineIcon sx={{ fontSize: 72 }} />
                        </Box>

                        <Typography
                            variant="h1"
                            sx={{
                                fontSize: { xs: '6rem', md: '8rem' },
                                fontWeight: 700,
                                color: 'error.main',
                                mb: 2,
                                lineHeight: 1
                            }}
                        >
                            404
                        </Typography>

                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: 600,
                                mb: 2,
                                color: 'text.primary'
                            }}
                        >
                            Página não encontrada
                        </Typography>

                        <Typography
                            sx={{
                                color: 'text.secondary',
                                fontSize: '1.1rem',
                                mb: 4,
                                maxWidth: 600,
                                mx: 'auto',
                                lineHeight: 1.7
                            }}
                        >
                            Não encontramos a página que você está procurando. Talvez você tenha digitado errado o endereço? Certifique-se de verificar se não existe erro de ortografia.
                        </Typography>

                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                            justifyContent="center"
                            sx={{ mt: 4 }}
                        >
                            <Button
                                onClick={handleGoBack}
                                size="large"
                                variant="outlined"
                                startIcon={<ArrowBackIcon />}
                                sx={{
                                    minWidth: 200,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    py: 1.5
                                }}
                            >
                                Voltar
                            </Button>
                            <Button
                                to="/"
                                size="large"
                                variant="contained"
                                component={RouterLink}
                                startIcon={<HomeIcon />}
                                sx={{
                                    minWidth: 200,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    py: 1.5
                                }}
                            >
                                Ir para o Login
                            </Button>
                        </Stack>
                    </Box>
                </Container>
            </Box>
        </React.Fragment>
    )
}